import { useEffect, useState, useCallback } from 'react'
import { apiGet } from '../../api'
import type { HomeOverview } from '../../api'
import DatesStrip from './DatesStrip'
import MentionedNotes from './MentionedNotes'
import GiftIdeas from './GiftIdeas'
import SmallActsCard from './SmallActsCard'
import WeekendPlanner from './WeekendPlanner'
import HerWeekAhead from './HerWeekAhead'
import FamilyCalendar from './FamilyCalendar'

export default function HomePanel() {
  const [data, setData] = useState<HomeOverview | null>(null)

  const load = useCallback(async () => {
    try {
      const res = await apiGet<HomeOverview>('/home/overview')
      setData(res)
    } catch { /* ignore */ }
  }, [])

  useEffect(() => {
    load()
    const t = setInterval(load, 5 * 60_000)
    return () => clearInterval(t)
  }, [load])

  if (!data) return (
    <section className="panel home">
      <div className="panel-header"><span style={{ color: 'var(--accent-claire)' }}>Home · Claire</span></div>
      <div className="empty-state">Loading…</div>
    </section>
  )

  const overdueAct = data.small_acts_due.length > 0
  const anniversarySoon = data.next_dates.some(d => d.days_until <= 30)
  const pulseHeader = overdueAct || anniversarySoon

  return (
    <section className="panel home">
      <div className="panel-header">
        <span style={{ color: 'var(--accent-claire)' }}>
          Home · Claire {pulseHeader && <span aria-hidden="true">·</span>}
        </span>
        {data.last_together && (
          <span className="muted mono">last together: {data.last_together.days_ago === 0 ? 'today' : `${data.last_together.days_ago}d ago`}</span>
        )}
      </div>

      <FamilyCalendar />

      <div className="panel-header" style={{ marginTop: '1rem' }}><span>Dates</span></div>
      <DatesStrip rows={data.next_dates} onChange={load} />

      <div className="panel-header" style={{ marginTop: '1rem' }}><span>She mentioned</span></div>
      <MentionedNotes rows={data.open_mentions} onChange={load} />

      <div className="panel-header" style={{ marginTop: '1rem' }}><span>Small acts</span></div>
      <SmallActsCard rows={data.small_acts_due} onChange={load} />

      <div className="panel-header" style={{ marginTop: '1rem' }}><span>Gift ideas</span></div>
      <GiftIdeas rows={data.gift_ideas} onChange={load} />

      <div className="panel-header" style={{ marginTop: '1rem' }}><span>Weekend</span></div>
      <WeekendPlanner plan={data.weekend_plan} onSaved={load} />

      <div className="panel-header" style={{ marginTop: '1rem' }}><span>Her week ahead</span></div>
      <HerWeekAhead events={data.her_week_ahead} />
    </section>
  )
}
